export default {
  translation: {
    REQUEST: "Requesting",
    SAVE: "Save",
    CANCEL: "Cancel",
    NOTES: "Notes",
    ADDFEEDBACK: "Add feedback",
    UPDATE: "Update",
    DATA_SHARING_PROTOCALL: "Data Sharing Protocol",
    DOWNLOAD_PDF: "Download PDF",
    FILTER: "Filter",
    CASE_DETAILS_ID: "OneView reference: ",
    CASE_DETAILS: "OneView reference",
    CASES: "Cases ",
    LOG_OUT: "Log Out",
    CREACT_CASE: "Create Case",
    REQUESTING: "Requesting",
    SAVING: "Saving",
    EDITOUTCOMEPOPUPHEAD: "Edit Outcome",
    CREATECASESUMMARY: "Create Case",
    EDIT: "Edit",
    CONFIRM: "Confirm",
    DELETE: "Delete",
    ADDENGAGEMENT: "Add Engagement +",
    ADDENGAGEMENTPOPUPHEAD: "Add ",
    EDITENGAGEMENTPOPUPHEAD: "Edit ",
    ADDKEYWORD: "Add",
  },
};
